<template>
  <nav class="my-navbar" :class="{ scrolled }" ref="navbar">
    <!-- LOGO區 -->
    <div class="logo">
      <router-link to="/">
        <img
          src="@/assets/logo.jpg"
          :alt="`${$COMPANY_NAME} (${$COMPANY_NAMEn}) Logo`"
        />
      </router-link>
    </div>

    <!-- (手機) 右側：會員 / 購物車 / 漢堡 -->
    <div class="mobile-icons" v-if="isMobile">
      <!-- 會員 ICON 下拉 (手機) -->
      <div
        class="my-dropdown mobile-user-dropdown"
        @mouseover="showDropdown"
        @mouseleave="hideDropdown"
      >
        <button type="button" class="icon-button" aria-label="會員選單" @click.stop>
          <font-awesome-icon :icon="['fas', 'user']" />
        </button>
        <!-- 下拉選單內容 -->
        <ul class="my-dropdown-menu">
          <li v-if="!isLoggedIn">
            <router-link to="/login">登入</router-link>
          </li>
          <li v-if="!isLoggedIn">
            <router-link to="/register">註冊</router-link>
          </li>
          <li v-if="isLoggedIn && firstName">你好, {{ firstName }} ♥️</li>
          <li v-if="isLoggedIn">
            <router-link to="/profile">修改資料</router-link>
          </li>
          <!-- <li v-if="isLoggedIn">
            <router-link to="/address">寄件地址</router-link>
          </li> -->
          <li v-if="isLoggedIn && userProfile.account">
            <router-link to="/cpassword">修改密碼</router-link>
          </li>
          <li v-if="isLoggedIn">
            <router-link  to="/orders">訂單查詢</router-link>
          </li>
          <li v-if="isLoggedIn">
            <!-- 登出 -->
            <button
              type="button"
              class="link-button"
              @click="handleLogout"
            >
              登出
            </button>
          </li>
        </ul>
      </div>

      <!-- 購物車 ICON (手機) -->
      <div class="cart-icon">
        <router-link to="/cart" class="icon-button" aria-label="購物車">
          <font-awesome-icon :icon="['fas', 'shopping-cart']" />
          <span v-if="cartCount > 0" class="cart-badge">{{ cartCount }}</span>
        </router-link>
      </div>

      <!-- 漢堡按鈕 (手機) -->
      <button class="hamburger" @click="toggleNav">
        &#9776;
      </button>
    </div>

    <!-- 手機版側邊欄 -->
    <div class="mobile-nav" :class="{ active: navVisible }">
      <button class="close-btn" @click="toggleNav">&times;</button>
      <ul>
        <li>
          <router-link to="/" exact-active-class="active-link" @click="closeNav"
            >首頁</router-link
          >
        </li>
        <li>
          <router-link
            to="/products"
            exact-active-class="active-link"
            @click="closeNav"
            >所有產品</router-link
          >
        </li>
        <li>
          <router-link
            to="/about"
            exact-active-class="active-link"
            @click="closeNav"
            >關於我們</router-link
          >
        </li>
        <li v-if="$Settings.BOOKING_ENABLED === '1'">
          <router-link to="/booking" exact-active-class="active-link" @click="closeNav"
            >美容預約</router-link
          >
        </li>
        <li>
          <router-link
            to="/contact"
            exact-active-class="active-link"
            @click="closeNav"
            >聯絡我們</router-link
          >
        </li>
        <!-- 保養知識 (手機版) -->
        <li
          class="my-dropdown"
          @mouseover="showCareDropdown"
          @mouseleave="hideCareDropdown"
        >
        <button type="button" class="my-dropdown-toggle" @click.stop>
          肌膚問題解答
          <span class="plus-sign">+</span>
        </button>
          <ul class="my-dropdown-menu">
            <li v-for="poster in posterTitles.slice(0, 5)" :key="poster.id">
              <router-link :to="`/posters/${poster.id}`" @click="closeNav">
                {{ poster.title }}
              </router-link>
            </li>
            <li v-if="posterTitles.length > 5" class="more-link">
              <router-link to="/posters" @click="closeNav">
                更多文章...
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <!-- overlay (黑幕) -->
    <div :class="{ 'overlay': navVisible }" @click="closeNav"></div>

    <!-- 桌面版選單 -->
    <ul class="desktop-nav">
      <li>
        <router-link to="/" exact-active-class="active-link">首頁</router-link>
      </li>
      <li>
        <router-link to="/products" exact-active-class="active-link"
          >所有產品</router-link
        >
      </li>
      <li>
        <router-link to="/about" exact-active-class="active-link"
          >關於我們</router-link
        >
      </li>
      <li v-if="$Settings.BOOKING_ENABLED === '1'">
        <router-link to="/booking" exact-active-class="active-link">美容預約</router-link>
      </li>
      <li>
        <router-link to="/contact" exact-active-class="active-link"
          >聯絡我們</router-link
        >
      </li>
      <!-- 保養知識 (桌機) -->
      <li
        class="my-dropdown"
        :class="{ 'force-hide-dropdown': careDropdownHidden }"
        @mouseover="showCareDropdown"
        @mouseleave="hideCareDropdown"
      >
        <button type="button" class="my-dropdown-toggle" @click.stop>
          肌膚問題解答
          <span class="plus-sign">+</span>
        </button>
        <ul class="my-dropdown-menu">
          <li v-for="poster in posterTitles.slice(0, 5)" :key="poster.id">
              <router-link :to="`/posters/${poster.id}`" @click="closeCareDropdown">
                {{ poster.title }}
              </router-link>
            </li>
          <li v-if="posterTitles.length > 5" class="more-link">
            <router-link to="/posters" @click="closeCareDropdown">
              更多文章...
            </router-link>
          </li>
        </ul>
      </li>
      <!-- 會員 (桌機) -->
      <li
        class="my-dropdown"
        @mouseover="showDropdown"
        @mouseleave="hideDropdown"
      >
        <button type="button" class="my-dropdown-toggle" @click.stop>
          會員{{ isLoggedIn ? "資料" : "登入" }} <font-awesome-icon :icon="['fas', 'user']" />
        </button>
        <ul class="my-dropdown-menu">
          <li v-if="!isLoggedIn">
            <router-link to="/login">登入</router-link>
          </li>
          <li v-if="!isLoggedIn">
            <router-link to="/register">註冊</router-link>
          </li>
          <li v-if="isLoggedIn && firstName">你好, {{ firstName }} ♥️</li>
          <li v-if="isLoggedIn">
            <router-link to="/profile">修改資料</router-link>
          </li>
          <!-- <li v-if="isLoggedIn">
            <router-link to="/address">寄件地址</router-link>
          </li> -->
          <li v-if="isLoggedIn && userProfile.account">
            <router-link to="/cpassword">修改密碼</router-link>
          </li>
          <li v-if="isLoggedIn">
            <router-link to="/orders">訂單查詢</router-link>
          </li>
          <li v-if="isLoggedIn">
            <button type="button" class="link-button" @click="handleLogout">
              登出
            </button>
          </li>
        </ul>
      </li>

      <!-- 購物車 (桌機) : 滑鼠移入 -> 顯示 mini cart；點擊 -> /cart -->
      <li
        class="cart-menu my-dropdown"
        @mouseover="onMouseEnter"
        @mouseleave="onMouseLeave"
      >
        <router-link to="/cart" class="cart-icon">
          購物車 <font-awesome-icon :icon="['fas', 'shopping-cart']" />
          <span v-if="cartCount > 0" class="cart-badge">{{ cartCount }}</span>
        </router-link>
        <!-- 下拉 / Mini Cart -->
        <transition name="fade">
          <div
            v-if="storeShowCartDropdown || showCartDropdownLocal"
            class="cart-dropdown"
          >
            <div v-if="cartCount === 0" class="empty-cart">
              購物車內目前沒有商品
            </div>
            <div v-else>
              <h4 class="title">最新加入項目</h4>
              <ul class="dropdown-list">
                <li
                  v-for="(item) in cartItems"
                  :key="item.product_id + '_' + item.variant_id"
                  class="dropdown-item"
                >
                  <img
                    v-if="item.image_url"
                    :src="item.image_url"
                    alt="商品圖"
                    class="item-image"
                  />
                  <div class="item-info">
                    <span class="item-title"
                      >{{ item.title }} - {{ item.variant_name }}</span
                    >
                    <div class="item-qty-ctrl">
                      <button type="button" @click.stop="navDecreaseQty(item)" :disabled="item.quantity <= 1">−</button>
                      <span class="item-qty-num">{{ item.quantity }}</span>
                      <button type="button" @click.stop="navIncreaseQty(item)" :disabled="item.quantity >= 99">+</button>
                    </div>
                    <span class="item-price">NT${{ item.discount_price }}</span>
                  </div>
                  <button
                    class="remove-button"
                    @click="removeItem(item.product_id, item.variant_id)"
                  >
                    <font-awesome-icon :icon="['fas', 'trash']" />
                  </button>
                </li>
              </ul>
              <!-- 優惠載入中 -->
              <div v-if="!navPromoLoaded" class="nav-gift-section" style="color:#999;">優惠載入中…</div>
              <!-- 滿額贈品 -->
              <div v-if="navEarnedGifts.length > 0 || navNextGift" class="nav-gift-section">
                <p class="nav-gift-title">🎁 滿額贈</p>
                <div v-for="g in navEarnedGifts" :key="g.id" class="nav-gift-item">
                  🎁 {{ g.gift_name }} × {{ g.gift_quantity }}
                </div>
                <div v-if="navNextGift" class="nav-gift-next">
                  再消費 NT${{ navNextGift.shortfall.toLocaleString() }} {{ navNextGift.more ? '即再加贈' : '即贈' }} {{ navNextGift.gift.gift_name }}<template v-if="Number(navNextGift.gift.gift_quantity) > 1"> × {{ navNextGift.gift.gift_quantity }}</template>
                </div>
              </div>
              <!-- 還差多少享折扣 / 免運 -->
              <div v-if="navPromoLoaded && (navActiveCoupon || navNextCoupon || navFreeShip)" class="nav-gift-section">
                <div v-if="navActiveCoupon" class="nav-gift-item">
                  🏷️ 已享 {{ Number(navActiveCoupon.discount_rate) }} 折（滿 NT${{ Number(navActiveCoupon.min_amount).toLocaleString() }}）<span v-if="navActiveCoupon.days_left != null" class="nav-coupon-expire">&ensp;⏳倒數{{ navActiveCoupon.days_left }}天</span>
                </div>
                <div v-else-if="navNextCoupon" class="nav-gift-next">
                  🏷️ 再消費 NT${{ (Number(navNextCoupon.min_amount) - navCartSubtotal).toLocaleString() }} 即可享 {{ Number(navNextCoupon.discount_rate) }} 折
                </div>
                <div v-if="navFreeShip && navCartSubtotal < Number(navFreeShip.free_shipping_threshold)" class="nav-gift-next">
                  🚚 再消費 NT${{ (Number(navFreeShip.free_shipping_threshold) - navCartSubtotal).toLocaleString() }} 即可免運（{{ navFreeShip.name }}）
                </div>
                <div v-else-if="navFreeShip" class="nav-gift-item">
                  🚚 已達免運（{{ navFreeShip.name }}）
                </div>
              </div>

              <div class="cart-summary">
                <div class="cart-summary-row">
                  <span>{{ navCouponDiscount > 0 ? '原價小計：' : '商品小計：' }}</span>
                  <span class="summary-price" :class="{ 'summary-price--crossed': navCouponDiscount > 0 }">NT${{ cartTotal }}</span>
                </div>
                <!-- 已套用折扣 -->
                <template v-if="navActiveCoupon && navCouponDiscount > 0">
                  <div class="cart-coupon-row">
                    <span class="cart-coupon-label">🏷️ {{ Number(navActiveCoupon.discount_rate) }}折優惠：</span>
                    <span class="cart-coupon-amt">－ NT${{ navCouponDiscount.toLocaleString() }}</span>
                  </div>
                  <div class="cart-final-row">
                    <span>折後總計：</span>
                    <span class="cart-final-price">NT${{ navFinalTotal.toLocaleString() }}</span>
                  </div>
                </template>
              </div>
              <div class="checkout-wrapper">
                <button class="btn-checkout" @click="navGoToCheckout">
                  結帳
                </button>
              </div>
            </div>
          </div>
        </transition>
      </li>
    </ul>


    <!-- 浮動按鈕區 (點擊切換布林showFloatingButtons)，美容預約頁不顯示 -->
    <div
      v-if="isMobile && !$route.path.startsWith('/booking') && !$route.path.startsWith('/store-apply')"
      class="floating-buttons"
    >


      <a v-if="showFloatingButtons && $Settings.COMPANY_LINE" :href="`${$Settings.COMPANY_LINE}`" target="_blank" rel="noopener" class="floating-btn btn-line" aria-label="LINE 客服">
        <svg data-v-054dcc2b="" class="floating-icon" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg"><path data-v-054dcc2b="" d="M14.7228 9.225V13.0339C14.7228 13.1304 14.6478 13.2054 14.5514 13.2054H13.9406C13.8817 13.2054 13.8281 13.1732 13.8014 13.1357L12.0549 10.7786V13.0393C12.0549 13.1357 11.9799 13.2107 11.8835 13.2107H11.2728C11.1764 13.2107 11.1014 13.1357 11.1014 13.0393V9.23036C11.1014 9.13393 11.1764 9.05893 11.2728 9.05893H11.8781C11.9317 9.05893 11.9906 9.08572 12.0174 9.13393L13.7639 11.4911V9.23036C13.7639 9.13393 13.8389 9.05893 13.9353 9.05893H14.546C14.6424 9.05357 14.7228 9.13393 14.7228 9.225V9.225ZM10.3299 9.05357H9.71921C9.62278 9.05357 9.54778 9.12857 9.54778 9.225V13.0339C9.54778 13.1304 9.62278 13.2054 9.71921 13.2054H10.3299C10.4264 13.2054 10.5014 13.1304 10.5014 13.0339V9.225C10.5014 9.13393 10.4264 9.05357 10.3299 9.05357V9.05357ZM8.85671 12.2464H7.19064V9.225C7.19064 9.12857 7.11564 9.05357 7.01922 9.05357H6.4085C6.31207 9.05357 6.23707 9.12857 6.23707 9.225V13.0339C6.23707 13.0821 6.25314 13.1196 6.28529 13.1518C6.31743 13.1786 6.35493 13.2 6.40314 13.2H8.85136C8.94778 13.2 9.02278 13.125 9.02278 13.0286V12.4179C9.02278 12.3268 8.94779 12.2464 8.85671 12.2464V12.2464ZM17.9371 9.05357H15.4888C15.3978 9.05357 15.3174 9.12857 15.3174 9.225V13.0339C15.3174 13.125 15.3924 13.2054 15.4888 13.2054H17.9371C18.0335 13.2054 18.1085 13.1304 18.1085 13.0339V12.4232C18.1085 12.3268 18.0335 12.2518 17.9371 12.2518H16.271V11.6089H17.9371C18.0335 11.6089 18.1085 11.5339 18.1085 11.4375V10.8214C18.1085 10.725 18.0335 10.65 17.9371 10.65H16.271V10.0071H17.9371C18.0335 10.0071 18.1085 9.93215 18.1085 9.83572V9.225C18.1031 9.13393 18.0281 9.05357 17.9371 9.05357V9.05357ZM24.146 4.37679V19.6607C24.1406 22.0607 22.1746 24.0053 19.7692 24H4.48529C2.08529 23.9946 0.14065 22.0232 0.146007 19.6232V4.33929C0.151364 1.93929 2.12279 -0.0053461 4.52279 1.10419e-05H19.8067C22.2067 0.00536818 24.1513 1.97144 24.146 4.37679ZM20.846 10.9446C20.846 7.03393 16.9246 3.85179 12.1085 3.85179C7.29243 3.85179 3.371 7.03393 3.371 10.9446C3.371 14.4482 6.47814 17.3839 10.6781 17.9411C11.7014 18.1607 11.5835 18.5357 11.3531 19.9125C11.3156 20.1321 11.1764 20.775 12.1085 20.3839C13.0406 19.9928 17.1388 17.4214 18.9763 15.3107C20.2406 13.9179 20.846 12.5089 20.846 10.9446Z" fill="currentColor">
        </path></svg>
      </a>
      <a v-if="showFloatingButtons && $Settings.COMPANY_INSTAGRAM" :href="`${$Settings.COMPANY_INSTAGRAM}`" target="_blank" rel="noopener" class="floating-btn btn-instagram" aria-label="Instagram">
       <svg data-v-054dcc2b="" class="floating-icon" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg"><g data-v-054dcc2b="" clip-path="url(#clip0_4527_91515)"><path data-v-054dcc2b="" fill-rule="evenodd" clip-rule="evenodd" d="M5.39661 0.0436591C5.68114 0.0200558 7.14491 0.0148926 12.1499 0.0148926H16.0518C18.8638 0.0197783 19.0238 0.0429532 19.558 0.120312L19.589 0.124795C20.745 0.291493 21.7149 0.752495 22.5079 1.51001C22.9523 1.93764 23.2584 2.35586 23.5341 2.91588C23.87 3.60001 24.0351 4.24725 24.1107 5.20982C24.1269 5.41635 24.1343 8.70311 24.1343 11.9921C24.1343 15.2805 24.1275 18.5733 24.1112 18.7799C24.0366 19.7271 23.8715 20.3799 23.546 21.0511C23.2283 21.709 22.7708 22.2896 22.2055 22.7524C21.6402 23.2152 20.9806 23.549 20.2729 23.7305C19.752 23.8651 19.2809 23.9283 18.4695 23.9665C18.18 23.9812 15.1521 23.9849 12.1243 23.9849C9.09642 23.9849 6.07041 23.9757 5.77353 23.9628C5.07281 23.9296 4.52698 23.8595 4.03279 23.7323C2.60553 23.3635 1.39402 22.3751 0.75968 21.0585C0.427759 20.3707 0.271019 19.7419 0.188038 18.7424C0.164066 18.4584 0.158534 16.9962 0.158534 11.9952C0.158534 11.3825 0.158291 10.8265 0.158069 10.321C0.157681 9.43662 0.157361 8.70711 0.158534 8.09975C0.163248 5.28463 0.186142 5.12668 0.264016 4.58944C0.26535 4.58024 0.266701 4.57092 0.268068 4.56147C0.434951 3.40676 0.895952 2.43533 1.6566 1.64573C2.07427 1.21276 2.49747 0.903888 3.03408 0.637429C3.73037 0.290756 4.3695 0.129037 5.39661 0.0436591ZM8.4946 3.20338C9.43874 3.16041 9.74041 3.1499 12.1443 3.1499H12.1417C14.5463 3.1499 14.8468 3.16041 15.791 3.20338C16.7333 3.24653 17.3768 3.39571 17.9411 3.61459C18.5238 3.84048 19.0161 4.1429 19.5085 4.63525C20.0008 5.12723 20.3032 5.62105 20.5301 6.20321C20.7477 6.766 20.897 7.40918 20.9413 8.35147C20.9837 9.2956 20.9947 9.59728 20.9947 12.0011C20.9947 14.405 20.9837 14.7059 20.9413 15.65C20.897 16.592 20.7477 17.2353 20.5301 17.7983C20.3032 18.3803 20.0008 18.8741 19.5085 19.3661C19.0167 19.8584 18.5236 20.1616 17.9416 20.3877C17.3785 20.6065 16.7345 20.7557 15.7923 20.7989C14.8481 20.8418 14.5474 20.8524 12.1433 20.8524C9.73968 20.8524 9.43818 20.8418 8.49405 20.7989C7.55195 20.7557 6.90858 20.6065 6.34542 20.3877C5.76363 20.1616 5.26981 19.8584 4.77801 19.3661C4.28585 18.8741 3.98343 18.3803 3.75717 17.7981C3.53847 17.2353 3.38929 16.5921 3.34596 15.6499C3.30318 14.7057 3.29248 14.405 3.29248 12.0011C3.29248 9.59728 3.30354 9.29542 3.34559 8.35129C3.388 7.40937 3.53736 6.766 3.7568 6.20302C3.98361 5.62105 4.28603 5.12723 4.77838 4.63525C5.27036 4.14308 5.76419 3.84067 6.34634 3.61459C6.90913 3.39571 7.55232 3.24653 8.4946 3.20338ZM11.8493 4.74488C11.6703 4.7448 11.5044 4.74473 11.3502 4.74497V4.74275C9.70058 4.7446 9.38415 4.75566 8.56763 4.79254C7.70463 4.83219 7.23607 4.97602 6.92407 5.09772C6.51101 5.25852 6.21597 5.4503 5.90617 5.76009C5.59638 6.06988 5.40424 6.36492 5.24381 6.77798C5.12266 7.08999 4.97846 7.55837 4.93899 8.42136C4.89658 9.35443 4.8881 9.63324 4.8881 11.9969C4.8881 14.3605 4.89658 14.6408 4.93899 15.5739C4.97827 16.4369 5.12266 16.9053 5.24381 17.2169C5.4046 17.6301 5.59638 17.9244 5.90617 18.2342C6.21597 18.544 6.51101 18.7358 6.92407 18.8962C7.23626 19.0174 7.70463 19.1616 8.56763 19.2014C9.50069 19.2438 9.7808 19.253 12.1443 19.253C14.5075 19.253 14.7878 19.2438 15.7209 19.2014C16.5839 19.162 17.0526 19.0181 17.3643 18.8964C17.7775 18.736 18.0716 18.5442 18.3814 18.2344C18.6912 17.9248 18.8834 17.6307 19.0438 17.2176C19.1649 16.906 19.3091 16.4376 19.3486 15.5746C19.391 14.6416 19.4002 14.3613 19.4002 11.9991C19.4002 9.63693 19.391 9.35664 19.3486 8.42357C19.3093 7.56058 19.1649 7.0922 19.0438 6.78056C18.883 6.36751 18.6912 6.07247 18.3814 5.76267C18.0718 5.45288 17.7773 5.2611 17.3643 5.10068C17.0523 4.97952 16.5839 4.83532 15.7209 4.79586C14.7876 4.75345 14.5075 4.74497 12.1443 4.74497C12.0421 4.74497 11.9439 4.74492 11.8493 4.74488ZM16.2788 6.39367C16.4535 6.27694 16.6589 6.21464 16.869 6.21464V6.21427C17.4554 6.21427 17.9311 6.69002 17.9311 7.27642C17.9312 7.48651 17.869 7.6919 17.7523 7.86661C17.6356 8.04133 17.4698 8.17753 17.2757 8.25798C17.0816 8.33842 16.868 8.35951 16.662 8.31857C16.4559 8.27763 16.2666 8.1765 16.1181 8.02797C15.9695 7.87944 15.8683 7.69018 15.8273 7.48414C15.7862 7.27809 15.8073 7.06451 15.8876 6.8704C15.968 6.6763 16.1042 6.51039 16.2788 6.39367ZM7.59879 12.0011C7.59879 9.49094 9.63391 7.45575 12.1441 7.45565C14.6543 7.45565 16.6892 9.49088 16.6892 12.0011C16.6892 14.5114 14.6545 16.5457 12.1443 16.5457C9.63402 16.5457 7.59879 14.5114 7.59879 12.0011ZM15.0947 12.0011C15.0947 10.3716 13.7736 9.05072 12.1443 9.05072C10.5147 9.05072 9.19385 10.3716 9.19385 12.0011C9.19385 13.6305 10.5147 14.9515 12.1443 14.9515C13.7736 14.9515 15.0947 13.6305 15.0947 12.0011Z" fill="currentColor"></path></g></svg>
      </a>
      <a v-if="showFloatingButtons && $Settings.COMPANY_FACEBOOK" :href="`${$Settings.COMPANY_FACEBOOK}`" target="_blank" rel="noopener" class="floating-btn btn-messenger" aria-label="Facebook">
        <svg data-v-054dcc2b="" class="floating-icon" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg"><path data-v-054dcc2b="" d="M24.146 12.073C24.146 5.40365 18.7424 0 12.073 0C5.40365 0 0 5.40365 0 12.073C0 18.0988 4.41493 23.0935 10.1866 24V15.563H7.11968V12.073H10.1866V9.41306C10.1866 6.38751 11.9878 4.71627 14.7466 4.71627C16.0678 4.71627 17.4494 4.95189 17.4494 4.95189V7.92146H15.9267C14.4273 7.92146 13.9594 8.85225 13.9594 9.8069V12.073H17.3077L16.7723 15.563H13.9594V24C19.7311 23.0935 24.146 18.0988 24.146 12.073Z" fill="currentColor"></path></svg>
      </a>
      <!-- <a v-if="showFloatingButtons" href="https://whatsapp.com" target="_blank" class="floating-btn btn-whatsapp">WhatsApp</a> -->

      <button
        v-if="showFloatingButtons" 
        type="button"
        class="floating-btn btn-top"
        aria-label="回到頂端"
        @click="scrollToTop"
      >
      ⇪
      </button>
      <button 
        type="button"
        class="floating-btn btn-showhide"
        :aria-label="showFloatingButtons ? '隱藏快捷按鈕' : '顯示快捷按鈕'"
        :title="showFloatingButtons ? '隱藏快捷按鈕' : '顯示快捷按鈕'"
        @click="toggleFloatingButtons" 
      >
      <!--   <font-awesome-icon
    :icon="[
      'fas', 
      showFloatingButtons ? 'angle-up' : 'angle-down'
    ]"
  />
   -->
   <font-awesome-icon
    :icon="[
      'fas', 
      showFloatingButtons ? 'angle-up' : 'angle-down'
    ]"
  />
      </button>     
    </div>
  </nav>
</template>

<script setup>
import { ref, computed , getCurrentInstance, onMounted } from 'vue'
import { useCartStore } from '@/store/cartStore'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

const instance = getCurrentInstance()
const posterTitles = instance.appContext.config.globalProperties.$PosterTitles

const router = useRouter()
const cartStore = useCartStore()
const storeShowCartDropdown = computed(() => cartStore.showCartDropdown)
const showCartDropdownLocal = ref(false)

import { loadGifts, loadCoupons, computeEarnedGifts, computeNextGift } from '@/utils/promoData'
import { checkStockRemote } from '@/utils/stock'
import { useSysTempStore } from '@/store/sysTempStore'

// 滿額贈
const navAllGifts = ref([])
const navEarnedGifts = computed(() => computeEarnedGifts(navAllGifts.value, navCartSubtotal.value))
// 下一個還沒達到的滿額贈（提示「再消費 NT$X 即贈…」）
const navNextGift = computed(() => computeNextGift(navAllGifts.value, navCartSubtotal.value))

async function fetchNavGifts(force = false) {
  try {
    navAllGifts.value = await loadGifts(force)
  } catch (e) { return }
}

// 折扣券
const navCouponSetup = ref(null)
const navAllCoupons = ref([])

function reloadNavCoupon() {
  try {
    const saved = localStorage.getItem('selectedCoupon')
    navCouponSetup.value = saved ? JSON.parse(saved) : null
  } catch (e) {
    navCouponSetup.value = null
  }
}

async function fetchNavCoupons(force = false) {
  try {
    navAllCoupons.value = await loadCoupons(force)
  } catch (e) { return }
}

// 從 Vuex 取得購物車小計
const store = useStore()
const navCartSubtotal = computed(() => store.getters.cartTotal)

// 達門檻的可用折扣券
const navAvailableCoupons = computed(() =>
  navAllCoupons.value.filter(c => navCartSubtotal.value >= c.min_amount)
)

// 還沒達門檻的折扣券中門檻最低的那張（顯示「再消費多少即可享幾折」）
const navNextCoupon = computed(() => {
  const notYet = navAllCoupons.value.filter(c => navCartSubtotal.value < Number(c.min_amount))
  if (!notYet.length) return null
  return notYet.reduce((a, b) => Number(a.min_amount) <= Number(b.min_amount) ? a : b)
})

// 免運門檻最低的啟用中物流（門檻看商品小計、未扣折扣券，與結帳計算一致）
const sysTemp = useSysTempStore()
const navFreeShip = computed(() => {
  const list = (sysTemp.shippingMethods || []).filter(m => m.is_active !== 0 && Number(m.free_shipping_threshold) > 0)
  if (!list.length) return null
  return list.reduce((a, b) => Number(a.free_shipping_threshold) <= Number(b.free_shipping_threshold) ? a : b)
})

// 實際生效的折扣券（與結帳頁同規則）：已選的券仍存在且達門檻就用它，否則用達門檻中最優惠的；都沒達門檻 → 不折
// 用最新抓到的券資料判斷門檻，避免 localStorage 存的舊券（門檻/折數已被後台改掉）或購物車減少後仍顯示折扣
const navActiveCoupon = computed(() => {
  const sub = navCartSubtotal.value
  const eligible = navAllCoupons.value.filter(c => sub >= Number(c.min_amount))
  if (!eligible.length) return null
  const saved = navCouponSetup.value && eligible.find(c => c.id === navCouponSetup.value.id)
  return saved || eligible.reduce((a, b) => Number(a.discount_rate) < Number(b.discount_rate) ? a : b)
})

// 折扣金額
const navCouponDiscount = computed(() => {
  if (!navActiveCoupon.value || !navCartSubtotal.value) return 0
  const discounted = Math.round(navCartSubtotal.value * Number(navActiveCoupon.value.discount_rate) / 10)
  return Math.max(0, navCartSubtotal.value - discounted)
})

// 折後總計
const navFinalTotal = computed(() =>
  Math.max(0, navCartSubtotal.value - navCouponDiscount.value)
)

// 網頁一打開就先抓好滿額贈與折扣券，滑鼠移到購物車時可立即顯示
const navPromoLoaded = ref(false)
onMounted(() => {
  Promise.all([fetchNavGifts(), fetchNavCoupons(), sysTemp.fetchShippingData()]).finally(() => { navPromoLoaded.value = true })
})

async function onMouseEnter() {
  showCartDropdownLocal.value = true
  reloadNavCoupon()
  // 先顯示已抓好的資料，同時在背景更新（兩個同時抓，不再一個等一個）
  await Promise.all([fetchNavCoupons(true), fetchNavGifts(true)])
  // 若無已選折扣券，自動套用最優惠的可用券
  if (!navCouponSetup.value && navAvailableCoupons.value.length > 0) {
    const best = navAvailableCoupons.value.reduce((a, b) =>
      Number(a.discount_rate) < Number(b.discount_rate) ? a : b
    )
    navCouponSetup.value = best
    localStorage.setItem('selectedCoupon', JSON.stringify(best))
  }
}
function onMouseLeave() {
  showCartDropdownLocal.value = false
}

async function navGoToCheckout() {
  // 庫存不足就改帶到購物車頁（那裡會顯示哪個商品不夠、可直接調整數量）
  const r = await checkStockRemote(store.state.cartItems)
  if (!r.ok) {
    router.push('/cart')
    return
  }
  localStorage.setItem('earnedGifts', JSON.stringify(navEarnedGifts.value))
  router.push('/checkout')
}
</script>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export default {
  name: 'AppNavbar',
  data() {
    return {
      showCartDropdown: false,
      navVisible: false, // 手機版側邊欄
      isMobile: false,
      dropdownVisible: false,
      careDropdownHidden: false,
      scrolled: false,
      showFloatingButtons: true, // 新增的布林，用於切換顯示/隱藏
    };
  },
  computed: {
    ...mapState(['userProfile', 'isLoggedIn', 'cartItems']),
    ...mapGetters(['cartCount', 'cartTotal']),
    firstName() {
      if (this.userProfile.username) {
        const username = this.userProfile.username;
        if (username.length > 3) {
          return `${username.substring(1, 3)}...`;
        }
        return username.substring(1);
      }
      return '';
    },
  },
  created() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    // 如果需要從 localStorage 讀取初始設定，可以在這裡做：
    const savedSetting = localStorage.getItem('showFloatingButtons');
    if (savedSetting !== null) {
      this.showFloatingButtons = JSON.parse(savedSetting);
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    ...mapActions(['logout', 'removeProductFromCart']),
    removeItem(productId, variantId) {
      this.removeProductFromCart({ productId, variantId });
    },
    // 下拉購物車直接加減數量（與購物車頁相同：1～99）
    navIncreaseQty(item) {
      if (item.quantity < 99) {
        item.quantity++;
        this.$store.commit('setCartItems', [...this.cartItems]);
      }
    },
    navDecreaseQty(item) {
      if (item.quantity > 1) {
        item.quantity--;
        this.$store.commit('setCartItems', [...this.cartItems]);
      }
    },
    handleLogout() {
      this.logout().then(() => {
        this.$router.push('/login');
      });
    },
    toggleNav() {
      this.navVisible = !this.navVisible;
      const mobileNav = this.$el.querySelector('.mobile-nav');
      if (this.navVisible) {
        disableBodyScroll(mobileNav);
      } else {
        enableBodyScroll(mobileNav);
      }
    },
    closeNav() {
      this.navVisible = false;
      const mobileNav = this.$el.querySelector('.mobile-nav');
      enableBodyScroll(mobileNav);
    },
    handleResize() {
      // 這裡斷點可自行定義 768 / 945 / 946 ...
      this.isMobile = window.innerWidth < 946;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    toggleFloatingButtons() {
      this.showFloatingButtons = !this.showFloatingButtons;
      localStorage.setItem('showFloatingButtons', JSON.stringify(this.showFloatingButtons));
    },
    showDropdown() {
      this.dropdownVisible = true;
    },
    hideDropdown() {
      this.dropdownVisible = false;
    },
    showCareDropdown() {
      this.careDropdownHidden = false;
    },
    hideCareDropdown() {
      this.careDropdownHidden = false;
    },
    closeCareDropdown() {
      this.careDropdownHidden = true;
      this.closeNav();
    },
    handleScroll() {
      this.scrolled = window.scrollY > 50;
    },
  },
};
</script>

<style scoped>
.my-navbar {
  position: fixed;
  top: 0; left: 0;
  width: 100%;
  height: 80px;
  background-color: #fff;
  z-index: 9999;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  display: flex;
  align-items: center;
  justify-content: space-between;
  /* 若畫面仍覺得擠，可以改成 padding: 0 16px; 或更小 */
  padding: 0 20px;
  transition: height 0.3s ease;
}
.my-navbar.scrolled {
  height: 60px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
}

.logo img {
  height: 60px;
  transition: height 0.3s ease;
  object-fit: cover;
}
.my-navbar.scrolled .logo img {
  height: 40px;
}

/* =================== 桌機版選單 =================== */
.desktop-nav {
  display: none;
}
@media (min-width: 946px) {
  .desktop-nav {
    display: flex;
    list-style: none;
    margin: 0; padding: 0;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
  .desktop-nav li {
    margin: 0 15px;
    position: relative;
  }
  .desktop-nav li a,
  .desktop-nav li button.my-dropdown-toggle {
    text-decoration: none;
    color: #333;
    padding: 10px 15px;
    background: none;
    border: none;
    cursor: pointer;
    transition: color 0.3s ease, background-color 0.3s ease;
    font: inherit;
  }
  .desktop-nav .active-link {
    background-color: #cc4a00;
    color: #fff;
  }
  .desktop-nav li a:hover,
  .desktop-nav li button.my-dropdown-toggle:hover {
    color: #fff;
    background-color: #b34100;
  }
}

/* =================== (手機) 右上角圖示 .mobile-icons =================== */
@media (max-width: 945px) {
  .mobile-icons {
    display: flex;
    align-items: center;
    /* 三個按鈕之間的距離，可自行調整 */
    gap: 16px;
    margin-left: auto; /* 靠右對齊 */
    margin-right: 20px;
    /* 若想更確定不會超出，可以再加一些 padding-right */
    /* padding-right: 8px; **/
     
  }
  .icon-button {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 24px;
    color: #333;
    position: relative;
  }
  .hamburger {
    background: none;
    border: none;
    font-size: 28px;
    color: #333;
    cursor: pointer;
  }
}

/* =================== 手機版側邊欄 (mobile-nav) =================== */
.mobile-nav {
  display: none;
}
@media (max-width: 945px) {
  .mobile-nav {
    position: fixed;
    top: 0; right: 0;
    width: 70%; height: 100%;
    background: #fff;
    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.2);
    display: flex; flex-direction: column;
    padding: 5px;
    transform: translateX(100%);
    transition: transform 0.3s ease-out;
    z-index: 2000;
    overflow-y: auto;
  }
  .mobile-nav.active {
    transform: translateX(0);
  }
  .mobile-nav ul {
    list-style: none;
    margin-top: 20px;
    padding: 0 0 0 20px;
    width: 100%;
  }
  .mobile-nav li {
    padding: 12px 0;
    border-bottom: 1px solid #eaeaea;
    position: relative;
  }
  .mobile-nav a {
    color: #333;
    text-decoration: none;
    font-size: 16px;
    display: block;
  }
  .close-btn {
    align-self: flex-end;
    background: none;
    border: none;
    font-size: 45px;
    cursor: pointer;
    padding: 10px;
    color: #000 !important;
  }
  .close-btn:hover {
    background-color: #f0f0f0 !important;
    color: #cc4a00 !important;
  }
  .my-dropdown-toggle {
    width: 100%;
    text-align: left;
    padding: 10px 0;
    font-size: 16px;
    background: none;
    border: none;
    cursor: pointer;
    color: #333;
  }
  .my-dropdown-toggle:hover {
    background-color: #f0f0f0;
  }

  .overlay {
    position: fixed; 
    top: 0; left: 0;
    width: 100%; height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    transition: opacity 0.3s ease;
    display: none;
  }
  .mobile-nav.active + .overlay {
    display: block;
  }

}

/* =================== 下拉選單 (hover) =================== */
.my-dropdown-menu {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  border-radius: 4px;
  list-style: none;
  margin: 0;
  padding: 5px 0;
  min-width: 360px;
  z-index: 1005;
  transform: translateY(-10px);
  transition: visibility 0s linear 0.3s,
              opacity 0.3s ease,
              transform 0.3s ease;
}
@media (max-width: 945px) {
  .my-dropdown-menu {
    min-width: unset;
    width: 100%;
    max-width: 280px;
  }
}
.my-dropdown:hover .my-dropdown-menu {
  visibility: visible;
  opacity: 1;
  transform: translateY(0);
  transition-delay: 0s;
}
.my-dropdown.force-hide-dropdown:hover .my-dropdown-menu {
  visibility: hidden;
  opacity: 0;
}
.my-dropdown-menu li {
  padding: 10px 20px;
  margin-bottom: 5px;
  border-bottom: 1px solid #f0f0f0;
}
.my-dropdown-menu li:last-child {
  margin-bottom: 0;
  border-bottom: none;
}
.link-button {
  background: none;
  border: none;
  color: #333;
  font: inherit;
  cursor: pointer;
  padding: 0;
  margin: 0;
  text-align: left;
  display: block;
  width: 100%;
}

.my-dropdown-menu li a:hover {
    color: #cc4a00;
    background-color: #fff;
}

@media (max-width: 945px) {
  .my-dropdown-menu li a:hover {
    color: #b34100;        /* 滑鼠移上變色 */
  }

}


/* =================== 購物車下拉 (Mini Cart) + 過場 =================== */
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.cart-menu {
  position: relative;
}
.cart-icon {
  cursor: pointer;
  position: relative;
  padding: 6px 10px;
}
.cart-badge {
  background-color: #ff0000;
  color: #fff;
  font-size: 14px;
  border-radius: 999px;
  padding: 2px 6px;
  margin-left: 4px;
  position: absolute;
  top: -3px;
  right: 1px;
}

@media (max-width: 945px) {
  .cart-badge{
      position: absolute;
      top: -10px;
      right: -12px;
  }
}
.cart-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  width: 400px; 
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.15);
  padding: 10px;
  z-index: 9999;
}
.empty-cart {
  text-align: center;
  color: #aaa;
  font-size: 0.95rem;
  padding: 20px 0;
}
.cart-dropdown .title {
  margin: 0 0 8px;
  font-size: 1.1rem;
  border-bottom: 1px solid #eee;
  padding-bottom: 4px;
}
.dropdown-list {
  max-height: 500px;
  overflow-y: auto;
  list-style: none;
  margin: 0; 
  padding: 0;
}
.dropdown-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  background: #fafafa;
  border-radius: 4px;
  padding: 10px;
}
.dropdown-item:hover {
  background: #f0f0f0;
}
.item-image {
  width: 50px;
  height: 50px;
  object-fit: cover;
  margin-right: 8px;
  border: 1px solid #eee;
  border-radius: 4px;
}
.item-info {
  display: flex;
  flex-direction: column;
  flex: 1;
  font-size: 0.9rem;
}
.item-title {
  font-weight: bold;
  margin-bottom: 2px;
}
.item-price {
  color: #e60000;
  font-weight: bold;
  margin-bottom: 2px;
}
.item-qty {
  color: #888;
  font-size: 0.8rem;
}
.item-qty-ctrl {
  display: inline-flex;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
  margin: 4px 0;
  width: fit-content;
  background: #fff;
}
.item-qty-ctrl button {
  width: 26px;
  height: 24px;
  border: none;
  background: #f2f2f2;
  font-size: 15px;
  line-height: 1;
  cursor: pointer;
  color: #333;
}
.item-qty-ctrl button:hover:not(:disabled) { background: #e6e6e6; }
.item-qty-ctrl button:disabled { color: #bbb; cursor: not-allowed; }
.item-qty-num {
  min-width: 30px;
  text-align: center;
  font-size: 0.85rem;
  color: #333;
}
.remove-button {
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  font-size: 1rem;
  margin-left: 8px;
}
.remove-button:hover {
  color: #666;
}
.cart-summary {
  margin-top: 8px;
  margin-bottom: 8px;
  font-weight: bold;
  color: #333;
}
/* 折扣券區 */
.nav-gift-section {
  border-top: 1px dashed #e0e0e0;
  padding: 8px 0 4px;
  margin-bottom: 4px;
}
.nav-gift-title {
  font-size: 0.82rem;
  font-weight: 700;
  color: #27ae60;
  margin: 0 0 4px;
}
.nav-gift-item {
  font-size: 0.82rem;
  color: #27ae60;
  padding: 2px 0;
}
.nav-gift-next {
  font-size: 0.82rem;
  color: #e67e22;
  padding: 2px 0;
}
.nav-coupon-section {
  border-top: 1px dashed #e0e0e0;
  padding: 8px 0 4px;
  margin-bottom: 4px;
}
.nav-coupon-title {
  font-size: 0.82rem;
  font-weight: 700;
  color: #cc4400;
  margin: 0 0 6px;
}
.nav-coupon-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 8px;
  border: 1px solid #e0c9b0;
  border-radius: 6px;
  margin-bottom: 4px;
  cursor: pointer;
  background: #fff8f3;
  transition: border-color .15s, background .15s;
}
.nav-coupon-card:hover { border-color: #ff6600; background: #fff3e8; }
.nav-coupon-card--on   { border-color: #ff6600; background: #ffe8d6; }
.nav-coupon-tag  { font-size: 0.82rem; font-weight: 600; color: #cc4400; display: flex; flex-direction: column; gap: 1px; }
.nav-coupon-after { font-size: 0.78rem; color: #c0392b; }
.nav-coupon-after strong { font-size: 0.92rem; font-weight: 700; }
.nav-coupon-expire { font-size: 0.72rem; color: #c0392b; font-weight: 700; }
.nav-coupon-check { font-size: 0.75rem; color: #27ae60; font-weight: 700; white-space: nowrap; }
.nav-coupon-use   { font-size: 0.75rem; color: #cc4a00; font-weight: 600; white-space: nowrap; }

.cart-summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.summary-price--crossed {
  text-decoration: line-through;
  color: #aaa;
  font-weight: 400;
  font-size: 0.88rem;
}
.cart-coupon-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;
  font-size: 0.82rem;
  font-weight: 600;
  color: #cc4400;
}
.cart-coupon-label { flex: 1; }
.cart-coupon-amt { white-space: nowrap; }
.cart-final-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4px;
  padding-top: 5px;
  border-top: 1px dashed #e0e0e0;
}
.cart-final-price {
  color: #c0392b;
  font-size: 1rem;
  font-weight: 700;
}
.checkout-wrapper {
  width: 100%;
  text-align: center; 
  margin-top: 10px;
}
.btn-checkout {
  display: inline-block;
  width: 100%;
  background: #cc4a00;
  color: #fff;
  text-align: center;
  padding: 8px 0;
  border-radius: 4px;
  text-decoration: none;
  font-size: 0.85rem;
  cursor: pointer;
}
.btn-checkout:hover {
  background: #b34100;
}

.my-dropdown-menu li a {
  color: #333;
  text-decoration: none;
  font: inherit;
  display: block;
  width: 100%;
  cursor: pointer;
  padding: 0;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
/* 「.my-dropdown-menu li a { font: inherit }」比較優先，要寫得比它具體才粗得起來 */
.my-dropdown-menu li.more-link a {
  color: #a33b00 !important;
  font-weight: bold;
}

</style>
<style scoped>
/* =================== 浮動按鈕區 (僅手機版時顯示) =================== */
/* 右下方浮動的容器 */
.floating-buttons {
  position: fixed;
  /* 因為你的 navbar 高度是 60~80px，可以視需要往上或往下調整 bottom */
  bottom: 20px;
  right: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px; /* icon 之間的距離 */
  z-index: 9999;
}

/* 浮動按鈕的通用樣式 */
.floating-btn {
  width: 48px;         /* icon 大小可自行調整 */
  height: 48px;
  border-radius: 50%;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  text-decoration: none;
  color: #333;
  font-size: 20px;
  transition: transform 0.2s ease, background-color 0.2s ease;
  cursor: pointer;
}

/* 可依照不同品牌做不同顏色。例如：Line (綠)、IG (粉)、Messenger(藍)、WhatsApp(綠) */
.btn-line {
  background-color: #00c300; /* LINE 綠 */
  color: white;
}
.btn-instagram {
  background: radial-gradient(
    circle at 30% 107%,
    #fdf497 0%,
    #fdf497 5%,
    #fd5949 45%,
    #d6249f 60%,
    #285aeb 90%
  );
  color: #fff;
}
.btn-messenger {
  background-color: #00b2ff;
  color: #fff;
}
.btn-whatsapp {
  background-color: #25d366;
  color: #fff;
}

.btn-showhide{
  background-color: #cc4a00;
  color: #fff;
}

/* 回到頂端按鈕 */
.btn-top {
  background-color: #292929;
  color: #fff;
}

/* hover 效果（可自訂放大/顏色變化等） */
.floating-btn:hover {
  transform: scale(1.1);
}

.floating-icon {
    width: 35px;
    height: 35px;
    fill: currentColor;
}

</style>
<style scoped>

/* 「+」符號額外樣式 + 動畫 */
.plus-sign {
  display: inline-block;
  margin-left: 1px;
  font-size: 1.2rem;
  font-weight: 900;   
  transition: transform 0.2s ease;
}

/* 滑過按鈕時，讓「+」稍微旋轉 */
.my-dropdown-toggle:hover .plus-sign {
  transform: rotate(90deg);
}
</style>